import styled from 'styled-components'

import theme from 'theme_'
import { BlurredBlock } from 'components/Layout'
import { CommonLinkButton } from 'components/Button'
import { Font14 } from 'components/Typography'

export const DeleteBtn = styled(CommonLinkButton)`
  height: 48px;
  width: 48px;
  top: -12px;
  right: -12px;
  position: absolute;
`

export const OuterContainer = styled.div`
  overflow: hidden;
`

interface CardProps {
  isDefault?: boolean
  isExpired?: boolean
  isSelected?: boolean
  isNonBold?: boolean
  isSmallFont?: boolean
}

export const CardLabelBase = styled.div<CardProps>`
  font-family: ${theme.fonts.base};
  ${Font14};
  line-height: 20px;
  margin-left: auto;
  color: ${(props) =>
    props.isDefault ? theme.colors.horizonOrange : theme.colors.darkeyGrey};
  ${(p) =>
    p.isExpired &&
    `
      color: ${theme.colors.error};
      font-weight: 700;
    `}
`

export const MakeCardDefault = styled(CardLabelBase)`
  color: ${(p) =>
    p.isDefault
      ? p.isSelected
        ? theme.colors.horizonOrange
        : theme.colors.darkeyGrey
      : theme.colors.horizonOrange};
  font-weight: 700;
  opacity: 0.4;

  &:hover {
    opacity: 1;
    color: ${theme.colors.horizonOrange};
    text-decoration: underline;
  }
`

export const CardDateLabel = styled(CardLabelBase)`
  color: ${theme.colors.otterWarmBlack};
`

export const Container = styled(BlurredBlock)<CardProps>`
  width: 100%;
  padding: 16px;
  cursor: pointer;
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.dolphinGrey};

  &:hover {
    border-color: ${theme.colors.horizonOrange};
  }

  ${(p) =>
    p.isExpired &&
    `
    box-shadow: inset 0 0 0 1px ${theme.colors.error};
  `}
  ${(p) =>
    p.isSelected &&
    !p.isExpired &&
    `
      border: 1px solid ${theme.colors.horizonOrange};
      background-color: rgba(255, 95, 0, 0.1);
  `}
`

export const PaymentSystem = styled.img`
  flex-shrink: 0;
  margin-right: 8px;
`

export const CardNumber = styled.div`
  display: flex;
  align-items: center;
`

export const DateRow = styled.div`
  position: relative;
  margin-top: 12px;
`

export const Last4Digits = styled.div<CardProps>`
  font-size: 18px;
  line-height: 20px;

  font-weight: 600;

  ${(p) => p.isNonBold && `font-weight: 400;`}
  ${(p) => p.isSmallFont && `font-size: 14px;`}

  color: ${(p) =>
    p.isSelected ? theme.colors.horizonOrange : theme.colors.otterWarmBlack};
`
